import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordGeneratorService {
  generatePassword(): string {
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%&*';
    const allChars = lowercaseChars + uppercaseChars + numbers + symbols;

    let password = '';

    // Ensure at least one of each required character type
    password += this.getRandomChar(lowercaseChars);
    password += this.getRandomChar(uppercaseChars);
    password += this.getRandomChar(numbers);
    password += this.getRandomChar(symbols);

    // Generate the rest of the password
    for (let i = 4; i < 9; i++) {
      password += this.getRandomChar(allChars);
    }

    // Shuffle the password characters
    password = this.shuffleString(password);

    return password;
  }

  private getRandomChar(characters: string): string {
    const randomIndex = Math.floor(Math.random() * characters.length);
    return characters[randomIndex];
  }

  private shuffleString(str: string): string {
    const array = str.split('');
    let currentIndex = array.length;
    let temporaryValue, randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array.join('');
  }
}
